import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild, enableProdMode } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { catchError, timeout } from 'rxjs/operators';

import { ProcuracaoService } from "src/app/services/procuracao.service";
import Swal from "sweetalert2";
import * as dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { DatePickerComponent, IDatePickerConfig } from "ng2-date-picker";
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { ContribuinteService } from "src/app/services/contribuinte.service";
import { ProdutorRuralService } from "src/app/services/produtor-rural.service";
import { CadastroProdutorRural } from "../../../../common/interface/cadastroProdutorRural";
import { of } from "rxjs";
import { dateFormatValidator, maxDateTodayValidator } from "src/app/utils/validators";

@Component({
  selector: 'app-cadastramento-produtor-rural',
  templateUrl: './cadastramento.component.html',
  styleUrls: ['./cadastramento.component.scss']
})
export class CadastramentoProdutorRuralComponent implements OnInit {

  @ViewChild('datePicker') datePicker: DatePickerComponent;

  @ViewChild('cepEnderecoPropriedade') cepEnderecoPropriedade: ElementRef;

  @ViewChild('cepEnderecoCorrespondencia') cepEnderecoCorrespondencia: ElementRef;

  @ViewChild('cepSocios') cepSocios: ElementRef;

  @ViewChild('tipoPessoaSocio') tipoPessoaSocio: ElementRef;

  @ViewChild('objetivoTextArea') objetivoTextArea: ElementRef<HTMLTextAreaElement>;

  @ViewChild('file_input') fileInput!: ElementRef;

  @ViewChild('inputAreaPropriedade') inputAreaPropriedade!: ElementRef;

  @ViewChild('inputAreaPastagemNatural') inputAreaPastagemNatural!: ElementRef;
  @ViewChild('inputAreaPastagemFormada') inputAreaPastagemFormada!: ElementRef;
  @ViewChild('inputAreaInexplorada') inputAreaInexplorada!: ElementRef;
  @ViewChild('inputAreaCultivada') inputAreaCultivada!: ElementRef;

  public latitudeLongitude = { '0': { pattern: new RegExp('[0-9\-\,]') } }

  carregado: boolean;
  contribuinteEmUso: string;
  procuracoes: any;
  situacao: any;
  dado: any;
  dados: any[] = [];
  data: any;
  active1: boolean = true;
  active2: boolean = false;
  active3: boolean = false;
  active4: boolean = false;
  active5: boolean = false;
  active6: boolean = false;
  active7: boolean = false;
  active8: boolean = false;
  produtorRuralForm: FormGroup;
  enderecoPropriedadeForm: FormGroup;
  informacoesEconomicasForm: FormGroup;
  cnaeForm: FormGroup;
  informacoesExploracaoForm: FormGroup;
  contabilistaForm: FormGroup;
  sociosForm: FormGroup;
  usuarioLogado: any;
  passo: number = 1;
  solicitante: string;
  campoMotivo: any;
  cpfCnpjSolicitante: string;
  emailSolicitante: string;
  readonly: boolean = false;
  ged: any;
  listaBic: any = [];
  listaComplemento: any;
  listaClassificacao: any;
  listaRegimeRecolhimento: any;
  listaNaturezaJuridica: any;
  listaCnae: any = [];
  listaOcupacao: any;
  listaPaises: any;
  listaGed: any;
  listaTipoImovel: any = [];
  dataAtual: any = new Date();
  loading: boolean = false;
  loadingReceita: boolean = false;
  loadingCrc: boolean = false;
  calendario: boolean = false;
  datePickerConfig: IDatePickerConfig = {
    disableKeypress: true,
    drops: "down",
    format: 'DD/MM/YYYY',
    min: dayjs().format('DD/MM/YYYY'),
  }
  datePickerConfigWithMax: IDatePickerConfig = {
    disableKeypress: false,
    drops: "down",
    format: 'DD/MM/YYYY',
    max: dayjs().format('DD/MM/YYYY'),
  }
  dataInicioProdutorRural: any;
  dataFimProdutorRural: Date = null;
  dataRegistro: Date = null;
  dataInicioSocio: any;
  dataFimSocio: Date = null;
  cnaeAberto: boolean = false;
  cnaePrincipal: boolean = false;
  cnae = [];
  cnaeCounter: number = 0;
  nomeCnae: string;
  codigo = 0
  sociosAberto: boolean = false;
  socios = [];
  pais: number = 30;
  sociosCounter: number = 0;
  participacaoCounter: number = 0;
  liberarAdicao: boolean = true;
  motivo: number = 1;
  cpfContrubuinte: string;
  mesmoEndereco: boolean = false;
  enderecoCorrespondencia: any;
  car: string;
  arquivos: any = [];
  arquivoValido: boolean = true;
  digitarCar: boolean = false;
  loadingCar: boolean = false;
  modalCarAtivo: boolean = false;
  dataCar: any;
  dadosPreenchidos: boolean = false;
  possuiSede: boolean = false;
  tipoImovel: any;

  areaImovel: string;
  areaLiquida: string;
  tipoComplemento: any;
  nomeResponsavel: any;
  cpfCnpjResponsavel: any;
  nProcuracaoResponsavel: any;
  tipoProcuracaoResponsavel: any;
  codTipoProcuracao: any;
  dataInicioVigencia: any;
  dataFinalVigencia: any;
  dadosIntegracaoFormatado: any;
  contribuinteEmUsoFormatado: any;
  latitudeModal: any;
  longitudeModal: any;
  arquivosComprovacaoContabilista: any[] = [];
  incras: string[] = [];
  cadastroEmUso: any;
  livro: any = '';
  folha: any = '';
  modalContabilistaAtivo: boolean = false;
  protocoloCarAdicionado: boolean = false;
  fonteContabilista: string = ''; 
  tituloModalContabilista: string = '';
  listaProprietario: any[] = [];
  modalProprietario: boolean = false;
  proprietarioSelecionado: any;
  exibirDadosProprietario: boolean = false;
  dadosCedente: boolean = false;
  cnpjCbsIbsValidado: boolean = false;
  loadingValidacaoCnpjCbsIbs: boolean = false;
  dadosCnpjCbsIbs: any = null;

  formValidacaoEndereco: FormGroup;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private procuracaoService: ProcuracaoService,
    private datePipe: DatePipe,
    private contribuinteService: ContribuinteService,
    private produtorRuralService: ProdutorRuralService,
    private renderer: Renderer2,
    private changeDetector: ChangeDetectorRef
  ) {
    dayjs.locale('pt-br');
    enableProdMode();
  }

  compareTipoComplemento(item1: any, item2: any): boolean {
    if (!item1 || !item2) return false;
    return item1.codigo === item2.codigo;
  }

  ngOnInit(): void {
    this.dadosIntegracaoFormatado = JSON.parse(localStorage.getItem('dadosIntegracao'));
    this.contribuinteEmUsoFormatado = JSON.parse(localStorage.getItem('contribuinteEmUso'));
    this.cadastroEmUso = this.dadosIntegracaoFormatado.sessao.cadastro;

    this.preencherSolicitacaoCadastramento();
    this.getBic();
    this.getListaComplemento();
    this.criarFormulario();
    this.getListaClassificacao();
    this.getListaRegimeRecolhimento();
    this.getListaNaturezaJuridica();
    this.getListaCnae();
    this.getListaOcupacao();
    this.getListaPaises();
    this.getListaGed();
    this.getListaTipoImovel();

    this.dataAtual.setHours(0, 0, 0);

    const areaCtrl = this.informacoesExploracaoForm.get('areaImovel')!;
    const pctCtrl = this.informacoesExploracaoForm.get('ocupacaoSolicitante')!;
    this.updateAreaOcupacao();
    areaCtrl.valueChanges.subscribe(() => {
      this.updateAreaOcupacao();
    });
    pctCtrl.valueChanges.subscribe(() => this.updateAreaOcupacao());

    this.informacoesExploracaoForm.get('categoriaOcupacao').valueChanges.subscribe(value => {
      if (value?.codigo === 1 && !this.informacoesExploracaoForm.controls.protocoloCar.value) {
        this.informacoesExploracaoForm.controls['cpfCnpjProprietario'].enable();
        this.informacoesExploracaoForm.controls['codigoProprietario'].enable();
        
        this.informacoesExploracaoForm.patchValue({
          nomeProprietario: this.solicitante,
          cpfCnpjProprietario: this.cpfCnpjSolicitante,
          emailProprietario: this.emailSolicitante,
          codigoProprietario: this.contribuinteEmUsoFormatado.codigo,
        });
      } else if(value?.codigo !== 1) {
        this.informacoesExploracaoForm.controls.nomeProprietario.reset();
        this.informacoesExploracaoForm.controls.cpfCnpjProprietario.reset();
        this.informacoesExploracaoForm.controls.emailProprietario.reset();
        this.informacoesExploracaoForm.controls.codigoProprietario.reset();
      }
    });
  }

  consultarCar() {
    const carValue = this.informacoesExploracaoForm.get('protocoloCar').value;
    if (!carValue || carValue.length < 7) {
      return;
    }
    this.loadingCar = true;

    this.produtorRuralService.getValidacaoCar(carValue)
      .pipe(
        timeout(10000),
        catchError(err => {
          Swal.fire({
            icon: 'error',
            text: 'CAR não localizado.'
          });
          this.informacoesExploracaoForm.controls.protocoloCar.setValue('');
          this.protocoloCarAdicionado = false;
          this.loadingCar = false;
          return of(null);
        })
      )
      .subscribe(
        res => {
          this.loadingCar = false;
          this.dataCar = res;
          this.informacoesExploracaoForm.controls.cpfCnpjProprietario.reset();
          this.informacoesExploracaoForm.controls.cpfCnpjProprietario.updateValueAndValidity();

          if (res) {
            const descricaoAcesso = `Código IBGE do município: ${res.imovel.codigoMunicipio}\n\n${res.imovel.descricaoAcesso}`;

            this.enderecoPropriedadeForm.patchValue({
              cep: res.imovel.cep,
              logradouro: res.imovel.enderecoCorrespondencia.logradouro,
              bairro: res.imovel.enderecoCorrespondencia.bairro,
              estado: res.imovel.enderecoCorrespondencia.siglaEstado,
              municipio: res.imovel.enderecoCorrespondencia.cidade,
              numero: res.imovel.enderecoCorrespondencia.numero,
              descricaoAcesso: descricaoAcesso,
              latitude: res.latitude,
              longitude: res.longitude,
              tipoComplemento: '',
            });

            const livro = this.dataCar?.documentos[0]?.detalheDocumentoPropriedade?.livro == "-"
              ? ''
              : this.dataCar?.documentos[0]?.detalheDocumentoPropriedade?.livro;
            const folha = this.dataCar?.documentos[0]?.detalheDocumentoPropriedade?.folha == "-"
              ? ''
              : this.dataCar?.documentos[0]?.detalheDocumentoPropriedade?.folha;
            const modulosFiscaisFonte = res.imovel.modulosFiscais;
            const modulosFiscais = modulosFiscaisFonte != null
              ? (Math.ceil(Number(modulosFiscaisFonte) * 100) / 100).toFixed(2).replace('.', ',')
              : '';

            this.informacoesExploracaoForm.patchValue({
              nomeImovel: res.imovel.nome,
              protocoloCar: res.imovel.numeroReciboEstadual,
              inscricaoIncra: '',
              numeroCar: res.imovel.numeroRecibo,
              modulosFiscais: modulosFiscais,
              areaImovel: this.formatArea4(this.dataCar?.geo?.find(g => g.tipo === 'AREA_IMOVEL_LIQUIDA')?.area),
              areaInexplorada: '',
              areaPastagemNatural: '',
              areaPastagemFormada: '',
              areaCultivada: '',
              valorEstimadoImovel: '',
              ocupacaoSolicitante: '',
              areaOcupacaoSolicitante: '',
              registroImobiliario: '',
              dataFim: '',
              observacao: res.documentos[0]?.detalheDocumentoPosse?.autodeclaracao,
              cpfCnpjProprietario: res.proprietariosPosseirosConcessionarios[0]?.cpfCnpj,
              emailProprietario: res.imovel.email,
              numeroMatricula: res.documentos[0]?.detalheDocumentoPropriedade?.numeroMatricula,
              livroProprietario:
                this.informacoesExploracaoForm?.get('categoriaOcupacao')?.value.codigo == 1
                  ? livro
                  : 'Não Informado',
              folhaProprietario:
                this.informacoesExploracaoForm?.get('categoriaOcupacao')?.value.codigo == 1
                  ? folha
                  : 'Não Informado',
              inscricaoImovel: '',
              numeroIncra: '',
            });

            this.areaImovel = this.dataCar?.geo?.find(g => g.tipo === 'AREA_IMOVEL')?.area;
            this.areaLiquida = this.dataCar?.geo?.find(g => g.tipo === 'AREA_IMOVEL_LIQUIDA')?.area;
            this.tipoComplemento = this.dataCar?.imovel?.enderecoCorrespondencia?.complemento;
            this.tipoImovel = this.dataCar.imovel.tipo;
            this.latitudeModal = this.dataCar.latitude;
            this.longitudeModal = this.dataCar.longitude;
            if (this.informacoesExploracaoForm?.get('categoriaOcupacao')?.value.codigo == 1) {
              this.livro = this.dataCar?.documentos[0]?.detalheDocumentoPropriedade?.livro;
              this.folha = this.dataCar?.documentos[0]?.detalheDocumentoPropriedade?.folha;
            } else {
              this.livro = 'Não Informado';
              this.folha = 'Não Informado';
            }

            if (this.tipoImovel === 'IRU') {
              this.tipoImovel = this.listaTipoImovel.find((data) => data.codigo == 1);
            } else if (this.tipoImovel === 'PCT') {
              this.tipoImovel = this.listaTipoImovel.find((data) => data.codigo == 2);
            } else if (this.tipoImovel === 'AST') {
              this.tipoImovel = this.listaTipoImovel.find((data) => data.codigo == 3);
            } else {
              this.tipoImovel = null;
            }

            this.informacoesExploracaoForm.controls.tipoImovel.setValue(this.tipoImovel);
            this.informacoesExploracaoForm.controls.tipoImovel.updateValueAndValidity();

            this.informacoesExploracaoForm.controls.ieProprietario.disable();

            this.setReadonlyFields();
            setTimeout(() => {
              this.validarCpfCnpjProprietario(this.informacoesExploracaoForm.controls.cpfCnpjProprietario.value);
            }, 100);
          }

          if (res && (res.imovel.status != 'Ativo')) {
            Swal.fire({
              icon: 'warning',
              html: `Prezado(a), <br> O seu Cadastro Ambiental Rural está com o status "${res.imovel.status}".<br>
              Para mais informações, acesse o 
              <a href="http://sigcar.semarh.to.gov.br/" target="_blank" style="color: blue; text-decoration: none;">
                Sistema de Informação para a Gestão do Cadastro Ambiental Rural de Tocantins
              </a>.`
            }).then(result => {
              if (result.isConfirmed) {
                this.router.navigate(['cadastro/produtor-rural/inscricao']);
              }
            });
          }
          this.loadingCar = false;
          if (res && (res.imovel.status === 'Ativo')) {
            this.modalCarAtivo = true;
          }
        },
      );
  }

  formatModulosFiscais(valor: any): string {
    if (valor == null) return '';
    const n = Number(valor);
    if (isNaN(n)) return '';
    return (Math.ceil(n * 100) / 100).toFixed(2).replace('.', ',');
  }

  onBlurModulosFiscais() {
    const ctrl = this.informacoesExploracaoForm.get('modulosFiscais');
    let valor = ctrl?.value;

    if (valor !== null && valor !== undefined) {
      const num = parseFloat(valor.toString().replace(',', '.'));

      if (!isNaN(num)) {
        const arredondado = num.toFixed(2).replace('.', ',');
        ctrl?.setValue(arredondado);
      }
    }
  }

  formatArea4(valor: any): string {
    if (valor == null) return '';
    const n = Number(String(valor).replace(',', '.'));
    if (isNaN(n)) return '';
    const trunc = Math.trunc(n * 10000) / 10000;
    return trunc.toFixed(4).replace('.', ',');
  }

  setReadonlyFields() {
    Object.keys(this.enderecoPropriedadeForm.controls).forEach(key => {
      const control = this.enderecoPropriedadeForm.get(key);
      if (control.value) {
        control.disable();
      }
    });
    Object.keys(this.informacoesExploracaoForm.controls).forEach(key => {
      const control = this.informacoesExploracaoForm.get(key);
      const value = control.value;
      if (
        value !== null &&
        value !== undefined &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0) &&
        !(typeof value === 'number' && value === 0)
      ) {
        control.disable({ emitEvent: false });
      }
    });
  }

  dadosProprietarioObrigatorio() {
    this.informacoesExploracaoForm.controls.cpfCnpjProprietario.setValidators([Validators.required]);
    this.informacoesExploracaoForm.controls.cpfCnpjProprietario.updateValueAndValidity();
    this.informacoesExploracaoForm.controls.nomeProprietario.setValidators([Validators.required]);
    this.informacoesExploracaoForm.controls.nomeProprietario.updateValueAndValidity();

    this.informacoesExploracaoForm.controls.nomeProprietario.disable();
    this.informacoesExploracaoForm.controls.ieProprietario.disable();
    this.informacoesExploracaoForm.controls.emailProprietario.disable();

    this.exibirDadosProprietario = true;
  }

  abrirModalCarAtivo() {
    this.modalCarAtivo = false;
    this.protocoloCarAdicionado = true;
    this.dadosProprietarioObrigatorio();
  }

  fecharModalCarAtivo() {
    this.modalCarAtivo = false;
    Swal.fire({
      icon: 'warning',
      html: `Prezado(a), <br>
      Para prosseguir com o cadastro, é necessário que antes seja feita a correção dos dados.
      Para mais informações, acesse o link do
      <a href="http://sigcar.semarh.to.gov.br/" target="_blank" style="color: blue; text-decoration: none;">
        Sistema de Informação para a Gestão do Cadastro Ambiental Rural
      </a>.`
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate(['cadastro/produtor-rural/inscricao']);
      }
    });
  }

  criarFormulario() {
    const tipoContribuinte = this.contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11 ? 2 : 1;
    this.produtorRuralForm = this.formBuilder.group({
      tipoContribuinte: [{ value: tipoContribuinte, disabled: true }, Validators.required],
    });

    this.enderecoPropriedadeForm = this.formBuilder.group({
      cep: ['', Validators.required],
      logradouro: ['', Validators.required],
      bairro: ['', Validators.required],
      municipio: ['', Validators.required],
      estado: ['', Validators.required],
      numero: ['', Validators.required],
      tipoComplemento: [''],
      descricaoAcesso: [''],
      localizacao: [{ value: '2', disabled: true }, Validators.required],
      latitude: [null, [Validators.min(-90), Validators.max(90)]],
      longitude: [null, [Validators.min(-180), Validators.max(180)]]
    });

    this.informacoesEconomicasForm = this.formBuilder.group({
      classificacaoContribuinte: [3],
      regimeRecolhimento: [0],
      naturezaJuridica: [89],
      cnaePrincipal: ['', Validators.required],
      adesaoCBS: [false],
      cnpj: ['']
    });
    this.informacoesEconomicasForm.disable();
    this.informacoesEconomicasForm.controls.cnaePrincipal.enable();
    this.informacoesEconomicasForm.controls.adesaoCBS.enable();
    this.informacoesEconomicasForm.controls.cnpj.enable();

    this.cnaeForm = this.formBuilder.group({
      cnae: ['', Validators.required],
      atividadePrincipal: [null, Validators.required],
      atividadePrimaria: [{ value: '1', disabled: false }, Validators.required],
    });

    this.informacoesExploracaoForm = this.formBuilder.group({
      protocoloCar: ['', Validators.minLength(7)],
      numeroCar: [''],
      nomeImovel: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
      tipoImovel: ['', Validators.required],
      areaImovel: ['', Validators.required],
      modulosFiscais: [0.00, Validators.required],
      areaPastagemNatural: [0],
      areaPastagemFormada: [0],
      areaInexplorada: [0],
      areaCultivada: [0],
      valorEstimadoImovel: [''],
      observacao: [null],
      categoriaOcupacao: ['', Validators.required],
      dataInicio: [this.datePipe.transform(new Date(), 'dd/MM/yyyy'), [Validators.required, dateFormatValidator, maxDateTodayValidator]],
      dataFim: [''],
      ocupacaoSolicitante: [null, [Validators.required, Validators.pattern(/^(?:[1-9][0-9]?|100)$/)]],
      areaOcupacaoSolicitante: [{ value: null, disabled: true }],
      nomeProprietario: [''],
      cpfCnpjProprietario: [''],
      emailProprietario: [''],
      registroImobiliario: [''],
      numeroMatricula: [''],
      livroProprietario: [''],
      folhaProprietario: [''],
      numeroIncra: [''],
      ieProprietario: [''],
      codigoProprietario: [''],
      inscricaoImovel: [''],
      documentosComprovacao: [[], Validators.required]
    });

    this.contabilistaForm = this.formBuilder.group({
      cpf: [''],
      nome: [''],
      crc: [''],
      email: [''],
      cep: [''],
      bairro: [''],
      tipoLogradouro: [''],
      logradouro: [''],
      numero: [''],
      codigoMunicipio: [''],
      municipio: [''],
      dscMunicipio: [''],
      estado: [''],
      complemento: [''],
      tipoComplemento: [''],
      documentosContabilista: [[]]
    });

    this.contabilistaForm.disable();
    this.contabilistaForm.controls.cpf.enable();

    this.sociosForm = this.formBuilder.group({
      pais: ['', Validators.required],
      cpfCnpj: ['', Validators.required],
      rg: [''],
      nome: ['', [Validators.required, Validators.minLength(2)]],
      participacao: ['', Validators.required],
      tipoPessoa: [{ value: 1, disabled: true }, Validators.required],
      funcaoPropriedadeRural: [{ value: '' }, Validators.required],
      dataEntrada: ['', Validators.required],
      dataSaida: [{ value: null }],
      enderecoCompleto: [null],
      cep: [null, Validators.required],
      logradouro: [null, Validators.required],
      numero: [null, Validators.required],
      tipoComplemento: [null],
      complemento: [null],
      latitude: [null, [Validators.min(-90), Validators.max(90)]],
      longitude: [null, [Validators.min(-180), Validators.max(180)]]
    });

    this.formValidacaoEndereco = this.formBuilder.group({
      cep: [null, Validators.required],
      numero: [null, Validators.required],
      complemento: [null],
    });
  }

  preencherSolicitacaoCadastramento() {
    this.verificarExistenciaCpfCnpj(this.contribuinteEmUsoFormatado?.dscCpfCnpj, 'solicitante');
    this.solicitante = this.contribuinteEmUsoFormatado?.cadastro?.dscNomeCadastro;
    this.cpfCnpjSolicitante = this.contribuinteEmUsoFormatado?.cadastro?.cpfCnpj;
    this.nProcuracaoResponsavel = this.contribuinteEmUsoFormatado?.seqProcuracao;
    const procuradores = this.dadosIntegracaoFormatado?.sessao?.procurador;
    const procuracao = Array.isArray(procuradores)
      ? procuradores.find(p => p.id === this.nProcuracaoResponsavel)
      : null;
    if (procuracao) {
      this.nomeResponsavel = this.cadastroEmUso.dscNomeCadastro;
      this.cpfCnpjResponsavel = this.cadastroEmUso.cpfCnpj;
      this.tipoProcuracaoResponsavel = procuracao.tipoProcuracao.dscTipoProcuracao;
      this.codTipoProcuracao = procuracao.tipoProcuracao.codTipoProcuracao;
      this.dataInicioVigencia = dayjs(procuracao.dataInicio).format('DD/MM/YYYY');
      this.dataFinalVigencia = dayjs(procuracao.dataFim).format('DD/MM/YYYY');
    }
  }

  getBic() {
    this.loading = true;
    this.contribuinteService.getDadosListaBic().subscribe(
      res => {
        this.listaBic = res;
        this.campoMotivo = this.listaBic.find((data) => data.id == 1);
      },
      err => {

      },
      () => {
        this.loading = false;
      }
    )
  }

  getListaComplemento() {
    this.produtorRuralService.getListaComplementos().subscribe(
      res => {
        this.listaComplemento = res;
      }
    )
  }

  getListaClassificacao() {
    this.produtorRuralService.getListaClassificacao().subscribe(
      res => {
        this.listaClassificacao = res;
      }
    )
  }

  getListaRegimeRecolhimento() {
    this.produtorRuralService.getListaRegimeRecolhimento().subscribe(
      res => {
        this.listaRegimeRecolhimento = res;
        this.informacoesEconomicasForm.controls.regimeRecolhimento.setValue(this.listaRegimeRecolhimento.find((data) => data.id == 0));
      }
    )
  }

  getListaNaturezaJuridica() {
    this.produtorRuralService.getListaNaturezaJuridica().subscribe(
      res => {
        this.listaNaturezaJuridica = res;
      }
    )
  }

  getListaCnae() {
    let params: {
      filtrar: 'true'
    }
    this.produtorRuralService.getListaCnae(params).subscribe(
      res => {
        this.listaCnae = res;
      }
    )
  }

  getNomeCnae() {
    let id = this.listaCnae[this.cnaeForm.controls.cnae.value].id;
    for (let i = 0; i < this.listaCnae.length; i++) {
      if (this.listaCnae[i].id == id) {
        this.nomeCnae = this.listaCnae[i].dscCnae;
      }
    }
  }

  getListaOcupacao() {
    this.produtorRuralService.getListaOcupacao().subscribe(
      (res: any) => {
        console.log('res', res);
        this.listaOcupacao = res.filter(item => !item.dataFim).sort((a, b) => a.descricao.localeCompare(b.descricao));
      },
      error => {
        console.error('Erro ao carregar lista de ocupações:', error);
      }
    );
  }

  getListaPaises() {
    this.produtorRuralService.getListaPaises().subscribe(
      res => {
        this.listaPaises = res;
      }
    )
  }

  getListaGed() {
    this.produtorRuralService.getListaGedIdentificador().subscribe(
      res => {
        this.listaGed = res;
      }
    )
  }

  getListaTipoImovel() {
    this.produtorRuralService.getListaTipoImovel().subscribe(
      (res: Array<any>) => {
        this.listaTipoImovel = res;
      }
    );
  }

  validarLatitude() {
    const latitude = this.enderecoPropriedadeForm.controls.latitude.value;
    if (latitude < -90 || latitude > 90) {
      this.enderecoPropriedadeForm.controls.latitude.setErrors({ invalid: true });
    }
  }

  validarLongitude() {
    const longitude = this.enderecoPropriedadeForm.controls.longitude.value;
    if (longitude < -180 || longitude > 180) {
      this.enderecoPropriedadeForm.controls.longitude.setErrors({ invalid: true });
    }
  }

  sanitizarNumeroEndereco(event: any, formGroup: FormGroup, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const valorAtual = input.value;
    
    const valorSanitizado = valorAtual.replace(/[^0-9A-Za-z\s\-\/]/g, '');

    if (valorAtual !== valorSanitizado) {
      const posicaoCursor = input.selectionStart ?? 0;
      const diferencaLength = valorAtual.length - valorSanitizado.length;
      
      formGroup.get(controlName)?.setValue(valorSanitizado, { emitEvent: false });
      input.value = valorSanitizado;
      
      const novaPosicao = Math.max(0, posicaoCursor - diferencaLength);
      input.setSelectionRange(novaPosicao, novaPosicao);
    }
  }

  cpfCnpjMask(cpfCnpj) {
    if (cpfCnpj.length == 11) {
      return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
    } else {
      return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
    }
  }

  verificarExistenciaCpfCnpj(cpfCnpj: string, form: string) {
    this.produtorRuralService.consultarCpfReceita(cpfCnpj).subscribe(
      res => {
        this.loadingReceita = false;
      },
      err => {
        this.loadingReceita = false;
        this.procuracaoService.getCpf(cpfCnpj).subscribe(
          res => {
            let data: any = res;
            if (data.length != 0) {
              if (form === 'solicitante') {
                this.emailSolicitante = data[0].emails[0]?.descricao || '';
              } else if (form === 'contabilista') {
                this.contabilistaForm.controls.cpf.setValue(data[0].cpfCnpj);
                this.contabilistaForm.controls.nome.setValue(data[0].dscNomeCadastro);
                this.contabilistaForm.controls.nome.disable();
                this.contabilistaForm.controls.email.setValue(data[0].emails[0]?.descricao || '');
                this.contabilistaForm.controls.email.disable();
                this.getEnderecoContabilista(data[0].cpfCnpj);
              } else {
                this.exibirPopupCpfCnpjEncontrado(data[0], form);
              }
            } else {
              this.exibirPopupPermitirDigitacao();
              if (form === 'contabilista') {
                this.validacaoCamposContabilista();
              }
            }
          },
          err => {
            Swal.fire({
              icon: 'error',
              text: 'Ocorreu um erro ao validar os dados, tente novamente.'
            });
          }
        );
      }
    );
  }

  exibirPopupCpfCnpjEncontrado(data: any, form: string) {
    const cpfCnpj = this.cpfCnpjMask(data.cpfCnpj);
    Swal.fire({
      icon: 'info',
      html: `
        <p>Atenção: Foi encontrado o C.P.F/C.N.P.J com os dados informados na SEFAZ TO.</p>
        <p>C.P.F/C.N.P.J: ${cpfCnpj}</p>
        <p>Nome: ${data.dscNomeCadastro}</p>
      `,
      confirmButtonText: 'Utilizar os dados encontrados',
      showCancelButton: true,
      cancelButtonText: 'Estes dados estão inconsistentes, não utilizar',
      allowOutsideClick: false
    }).then((result) => {
      this.loading = false;
      if (result.isConfirmed) {
        if (form === 'socios') {
          this.sociosForm.controls.nome.setValue(data.dscNomeCadastro);
          this.sociosForm.controls.nome.disable();
        }
      } else if (result.isDismissed) {
        this.exibirPopupPermitirDigitacao();
      }
    });
  }

  exibirPopupPermitirDigitacao() {
    Swal.fire({
      icon: 'info',
      text: `Atenção: Será permitida a digitação dos dados que serão validados posteriormente pela Auditoria Fiscal.`
    });
  }

  getEnderecoContabilista(cpfCnpj: string) {
    this.produtorRuralService.getEnderecoContribuinte(cpfCnpj).subscribe((data: any) => {
      const enderecoEstabelecimento = data.filter(item => item.tipoEndereco?.codigo === 3);

      this.contabilistaForm.controls.cep.setValue(enderecoEstabelecimento[0]?.endereco?.cep?.codCep || '');
      this.contabilistaForm.controls.bairro.setValue(enderecoEstabelecimento[0]?.endereco?.cep?.dscBairro || '');
      this.contabilistaForm.controls.logradouro.setValue(enderecoEstabelecimento[0]?.endereco?.cep?.dscLogradouro || '');
      this.contabilistaForm.controls.numero.setValue(enderecoEstabelecimento[0]?.endereco?.dscNumero || '');
      this.contabilistaForm.controls.municipio.setValue(enderecoEstabelecimento[0]?.endereco?.cep?.cidade?.dscCidade || '');
      this.contabilistaForm.controls.estado.setValue(enderecoEstabelecimento[0]?.endereco?.cep?.cidade?.estado?.codigo || '');
      this.contabilistaForm.controls.complemento.setValue(enderecoEstabelecimento[0]?.endereco?.dscComplemento || '');
      const tipoComplemento = enderecoEstabelecimento[0]?.endereco?.tipoComplemento;
      const selecionado = this.listaComplemento?.find(item => item.codigo === tipoComplemento?.codigo);
      this.contabilistaForm.controls.tipoComplemento.setValue(selecionado || '');

      this.abrirModalContabilista();
    }, (error) => {
      Swal.fire({
        icon: 'error',
        text: 'Ocorreu um erro ao validar os dados, tente novamente.'
      });
    });
  }

  validacaoCamposContabilista() {
    this.contabilistaForm.enable();
    const camposObrigatorios = [
      'nome', 'crc', 'email', 'cep', 'bairro', 'logradouro', 'numero', 'municipio', 'estado', 'documentosContabilista'
    ];

    camposObrigatorios.forEach(campo => {
      if (campo === 'email') {
        this.contabilistaForm.controls[campo].addValidators([Validators.required, Validators.email]);
      } else {
        this.contabilistaForm.controls[campo].addValidators(Validators.required);
      }
      this.contabilistaForm.controls[campo].updateValueAndValidity();
    });
  }

  abrirModalContabilista() {
    this.validacaoCamposContabilista();
    this.modalContabilistaAtivo = true;
  }

  fecharModalContabilista() {
    if (this.fonteContabilista === 'receita') {
      Swal.fire({
        icon: 'warning',
        text: 'Os dados informados do contabilista estão divergentes do registro da Receita Federal. Por favor, regularize as informações diretamente com a Receita Federal ou, se preferir, prossiga sem incluir os dados do contabilista.',
        confirmButtonText: 'OK'
      });
    }

    this.contabilistaForm.reset();
    this.contabilistaForm.disable();
    this.contabilistaForm.controls.cpf.enable();
    this.contabilistaForm.controls.crc.reset();
    this.arquivosComprovacaoContabilista = [];
    this.modalContabilistaAtivo = false;
    this.fonteContabilista = '';
  }

  confirmarModalContabilista() {
    this.modalContabilistaAtivo = false;
    this.habilitarCamposVaziosContabilista();
  }

  habilitarCamposVaziosContabilista() {
    const camposEditaveisSeVazios = ['logradouro', 'bairro', 'numero', 'tipoComplemento'];
    const todosCampos = [
      'cpf', 'nome', 'crc', 'email', 'cep', 'bairro', 'logradouro',
      'tipoLogradouro', 'numero', 'municipio', 'estado', 'tipoComplemento',
      'complemento', 'codigoMunicipio'
    ];

    if (this.fonteContabilista === 'receita') {
      todosCampos.forEach(campo => {
        const control = this.contabilistaForm.controls[campo];

        if (control) {
          const valor = control.value;
          let campoVazio = !valor ||
            valor === '' ||
            valor === 'Não informado' ||
            valor === 'N/A' ||
            (typeof valor === 'string' && valor.trim() === '');

          if (campo === 'logradouro' && valor === 'Não Localizados nos Correios') {
            campoVazio = true;
          }

          if (campo === 'numero' && valor === 'S/N') {
            campoVazio = true;
          }

          if (campo === 'email') {
            control.enable();
            control.setValidators([Validators.required, Validators.email]);
            control.updateValueAndValidity();
          }
          else if (campo === 'tipoComplemento') {
            if (campoVazio) {
              control.enable();
            } else {
              control.disable();
            }
          }
          else if (camposEditaveisSeVazios.includes(campo) && campoVazio) {
            control.enable();

            if (campo === 'logradouro' || campo === 'bairro' || campo === 'numero') {
              control.setValidators(Validators.required);
            }

            control.updateValueAndValidity();
          } else {
            control.disable();
          }
        }
      });
    } else {
      todosCampos.forEach(campo => {
        const control = this.contabilistaForm.controls[campo];

        if (control) {
          const valor = control.value;
          let campoVazio = !valor ||
            valor === '' ||
            valor === 'Não informado' ||
            valor === 'N/A' ||
            (typeof valor === 'string' && valor.trim() === '');

          if (campo === 'logradouro' && valor === 'Não Localizados nos Correios') {
            campoVazio = true;
          }
          
          if (campo === 'numero' && valor === 'S/N') {
            campoVazio = true;
          }

          if (campo === 'email') {
            control.enable();
            control.setValidators([Validators.required, Validators.email]);
            control.updateValueAndValidity();
          }
          else if (campo === 'tipoComplemento') {
            if (campoVazio) {
              control.enable();
            } else {
              control.disable();
            }
          }
          else if (campoVazio) {
            control.enable();

            if (campo === 'cpf' || campo === 'nome' || campo === 'crc' ||
              campo === 'cep' || campo === 'bairro' || campo === 'logradouro' ||
              campo === 'numero' || campo === 'municipio' || campo === 'estado') {
              control.setValidators(Validators.required);
            }

            control.updateValueAndValidity();
          } else {
            control.disable();
          }
        }
      });
    }

    this.contabilistaForm.controls.cpf.enable();
    this.contabilistaForm.controls.crc.enable();
    this.contabilistaForm.controls.crc.setValidators(Validators.required);
    this.contabilistaForm.controls.crc.updateValueAndValidity();
  }

  consultarDadosContabilista(cpfCnpj: string) {
    const documento = cpfCnpj.replace(/\D/g, '');
    const isValidCpf = documento.length === 11;
    this.contribuinteService.consultarCadastroCompletoSfera(documento).subscribe(
      (responseSfera: any) => {
        if (responseSfera && responseSfera.cpfCnpj) {
          this.loadingReceita = false;
          this.fonteContabilista = 'sfera';
          this.tituloModalContabilista = 'Atenção! Foi encontrado o CPF/CNPJ na base de dados da SEFAZ/TO';
          this.preencherFormularioContabilistaSfera(responseSfera);
          this.abrirModalContabilista();
        } else {
          this.consultarBCadastros(documento, isValidCpf);
        }
      },
      (errorSfera) => {
        this.consultarBCadastros(documento, isValidCpf);
      }
    );
  }

  consultarBCadastros(documento: string, isValidCpf: boolean) {
    const consultaService = isValidCpf ?
      this.contribuinteService.consultarCpfBcadastro(documento) :
      this.contribuinteService.consultarCnpjBcadastro(documento);

    consultaService.subscribe(
      (response: any) => {
        this.loadingReceita = false;
        if (response && (isValidCpf ? response.cpfId : response.cnpj)) {
          this.fonteContabilista = 'receita';
          this.tituloModalContabilista = 'Atenção! Foi encontrado o CPF/CNPJ na base de dados da Receita Federal';
          this.preencherFormularioContabilistaBcadastro(response, isValidCpf);
          this.abrirModalContabilista();
        } else {
          console.log('Dados não encontrados em nenhuma base');
          this.exibirPopupCpfCnpjInvalido();
          this.limparFormularioContabilista();
        }
      },
      (error) => {
        this.loadingReceita = false;
        console.error('Erro ao consultar dados do contabilista no b-Cadastros:', error);
        this.exibirPopupCpfCnpjInvalido();
        this.limparFormularioContabilista();
      }
    );
  }

  limparFormularioContabilista() {
    this.contabilistaForm.reset();
    this.contabilistaForm.disable();
    this.contabilistaForm.controls.cpf.enable();
  }

  preencherFormularioContabilistaSfera(dadosSfera: any) {
    const tipoComplemento = dadosSfera.endereco?.tipoComplemento || null;
    const logradouro = dadosSfera.endereco?.dscLogradouro ||
      dadosSfera.endereco?.cep?.dscLogradouro ||
      'Não informado';

    const cepValue = dadosSfera.endereco?.cep?.codCep || '';

    this.contabilistaForm.patchValue({
      cpf: dadosSfera.cpfCnpj || '',
      nome: dadosSfera.dscNomeRazao || 'Não informado',
      email: dadosSfera.email || 'Não informado',
      cep: cepValue,
      bairro: dadosSfera.endereco?.dscBairro || 'Não informado',
      logradouro: logradouro,
      numero: dadosSfera.endereco?.dscNumero || 'Não informado',
      municipio: dadosSfera.endereco?.cep?.cidade?.dscCidade || 'Não informado',
      estado: dadosSfera.endereco?.cep?.cidade?.estado?.dscUf || 'Não informado',
      tipoComplemento: tipoComplemento,
      complemento: dadosSfera.endereco?.dscComplemento || 'Não informado',
      codigoMunicipio: 'Não informado'
    });

    this.bloquearCamposContabilista();
    this.contabilistaForm.controls.email.enable();
  }

  preencherFormularioContabilistaBcadastro(dadosBcadastro: any, isCpf: boolean) {
    const tipoComplementoOutros = this.listaComplemento?.find(item => item.codigo === 99) || null;

    if (isCpf) {
      const cepValue = dadosBcadastro.cep || '';

      this.contabilistaForm.patchValue({
        cpf: dadosBcadastro.cpfId || '',
        nome: dadosBcadastro.nomeContribuinte || 'Não informado',
        email: dadosBcadastro.email || 'Não informado',
        cep: cepValue,
        bairro: dadosBcadastro.bairro || 'Não informado',
        tipoLogradouro: dadosBcadastro.tipoLogradouro || 'Não informado',
        logradouro: dadosBcadastro.logradouro || 'Não informado',
        numero: dadosBcadastro.nroLogradouro || 'Não informado',
        municipio: dadosBcadastro.ufMunDomic || 'Não informado',
        estado: dadosBcadastro.ufMunDomic || 'Não informado',
        tipoComplemento: tipoComplementoOutros,
        complemento: dadosBcadastro.complemento || 'Não informado',
        codigoMunicipio: dadosBcadastro.codMunDomic || 'Não informado'
      });
    } else {
      const cepValue = dadosBcadastro.cep || '';

      this.contabilistaForm.patchValue({
        cpf: dadosBcadastro.cnpj || '',
        nome: dadosBcadastro.nomeEmpresarial || dadosBcadastro.nomeFantasia || 'Não informado',
        email: dadosBcadastro.email || 'Não informado',
        cep: cepValue,
        bairro: dadosBcadastro.bairro || 'Não informado',
        logradouro: dadosBcadastro.logradouro || 'Não informado',
        numero: dadosBcadastro.numero === 'S/N' ? 'Não informado' : dadosBcadastro.numero || 'Não informado',
        municipio: dadosBcadastro.cidade && dadosBcadastro.cidade !== 'Município não cadastrado.'
          ? dadosBcadastro.cidade
          : 'Não informado',
        estado: dadosBcadastro.uf || 'Não informado',
        tipoComplemento: tipoComplementoOutros,
        complemento: dadosBcadastro.complemento || 'Não informado',
        codigoMunicipio: dadosBcadastro.codigoMunicipio || 'Não informado'
      });
    }
    this.bloquearCamposContabilista();
    this.contabilistaForm.controls.email.enable();
  }

  bloquearCamposContabilista() {
    this.contabilistaForm.controls.nome.disable();
    if (this.contabilistaForm.controls.cep.value) {
      this.contabilistaForm.controls.cep.disable();
    }

    this.contabilistaForm.controls.bairro.disable();
    this.contabilistaForm.controls.logradouro.disable();
    this.contabilistaForm.controls.numero.disable();
    this.contabilistaForm.controls.municipio.disable();
    this.contabilistaForm.controls.estado.disable();

    if (this.contabilistaForm.controls.tipoLogradouro) {
      this.contabilistaForm.controls.tipoLogradouro.disable();
    }
    if (this.contabilistaForm.controls.codigoMunicipio) {
      this.contabilistaForm.controls.codigoMunicipio.disable();
    }
    if (this.contabilistaForm.controls.complemento && this.contabilistaForm.controls.complemento.value !== 'Não informado') {
      this.contabilistaForm.controls.complemento.disable();
    }
    if (this.contabilistaForm.controls.tipoComplemento && this.contabilistaForm.controls.tipoComplemento.value) {
      this.contabilistaForm.controls.tipoComplemento.disable();
    }
  }

  exibirPopupCpfCnpjInvalido() {
    Swal.fire({
      icon: 'error',
      text: 'CPF/CNPJ não encontrado nas bases Sfera e B-Cadastro. Verifique as informações e tente novamente.',
      confirmButtonText: 'OK'
    });
  }

  validarTipoComplemento(form: string) {
    if (form == 'enderecoPropriedade') {
      if (this.enderecoPropriedadeForm.controls.tipoComplemento) {
        this.enderecoPropriedadeForm.controls.complemento.setValidators(Validators.required);
        this.enderecoPropriedadeForm.controls.complemento.updateValueAndValidity();
      }
    }
    if (form == 'socios') {
      if (this.sociosForm.controls.tipoComplemento) {
        this.sociosForm.controls.complemento.setValidators(Validators.required);
        this.sociosForm.controls.complemento.updateValueAndValidity();
      }
    }
    if (form == 'contabilista') {
      if (this.contabilistaForm.controls.tipoComplemento) {
        this.contabilistaForm.controls.complemento.setValidators(Validators.required);
        this.contabilistaForm.controls.complemento.updateValueAndValidity();
      }
    }
  }

  validarDigitoCpfCnpj(form: string) {
    if (form == 'contabilista') {
      const cpfValue = this.contabilistaForm.controls.cpf.value;

      if (cpfValue == undefined || cpfValue.length == 0) {
        this.contabilistaForm.reset();
        this.contabilistaForm.disable();
        this.contabilistaForm.controls.cpf.enable();
        this.contabilistaForm.controls.cpf.setErrors(null);
        this.arquivosComprovacaoContabilista = [];
      } else if (cpfValue.length !== 11 && cpfValue.length !== 14) {
        this.contabilistaForm.controls.cpf.setErrors({ invalid: true });
        Swal.fire({
          icon: 'error',
          text: 'CPF/CNPJ inválido, insira um valor válido.',
          confirmButtonText: 'OK'
        });
        this.limparFormularioContabilista();
      } else {
        this.contabilistaForm.controls.cpf.setErrors(null);
        this.loadingReceita = true;
        this.consultarDadosContabilista(cpfValue);
      }
    }
    if (form == 'socios') {
      if (cpf.isValid(this.sociosForm.controls.cpfCnpj.value) == false && this.sociosForm.controls.cpfCnpj.value.length == 11) {
        this.sociosForm.controls.cpfCnpj.setErrors({ 'invalid': true });
        this.sociosForm.controls.nome.reset();
        this.sociosForm.controls.nome.enable();
      } else if (
        (this.sociosForm.controls.cpfCnpj.value.length > 0 && this.sociosForm.controls.cpfCnpj.value.length < 11
          || this.sociosForm.controls.cpfCnpj.value.length > 12 && this.sociosForm.controls.cpfCnpj.value.length < 14)
      ) {
        this.sociosForm.controls.cpfCnpj.setErrors({ 'invalid': true });
        this.sociosForm.controls.nome.reset();
        this.sociosForm.controls.nome.enable();
      } else if (cnpj.isValid(this.sociosForm.controls.cpfCnpj.value) == false && this.sociosForm.controls.cpfCnpj.value.length == 14) {
        this.sociosForm.controls.cpfCnpj.setErrors({ 'invalid': true });
        this.sociosForm.controls.nome.reset();
        this.sociosForm.controls.nome.enable();
      } else {
        this.sociosForm.controls.cpfCnpj.setErrors(null);
        this.sociosForm.controls.nome.setValue('');
        this.sociosForm.controls.nome.enable();
        this.loadingReceita = true;
        this.verificarExistenciaCpfCnpj(this.sociosForm.controls.cpfCnpj.value, 'socios');
      }
    }
  }

  validarCpfCnpjProprietario(dado: string): void {
    if(this.informacoesExploracaoForm.controls.cpfCnpjProprietario.invalid) { 
      this.limparCamposProprietario();
      return;
    } 
    
    this.loading = true;
    this.consultarProprietario(dado);
  }

  consultarProprietario(cpfCnpj: string): void {
    const cpfCnpjSemFormatacao = cpfCnpj.replace(/\D/g, '');
    this.contribuinteService.pesquisarProprietario(cpfCnpjSemFormatacao).subscribe((res: any) => {
      if(res.length == 0) {
        this.pesquisarProprietarioBCadastros();
        return;
      }

      if(this.informacoesExploracaoForm.controls.protocoloCar.value) {
        this.preencherCamposProprietario(res[0])
      } else {
        Swal.fire({
          icon: 'success',
          text: 'Dados do proprietário obtidos com sucesso na base Sfera.'
        }).then(() => {
          if(res.length == 1) {
            this.preencherCamposProprietario(res[0]);
          } else if(res.length > 1) {
            this.listaProprietario = res;
            this.modalProprietario = true;
          }
        });
      }

      this.loading = false;
      
    }, error => {
      Swal.fire({
        icon: 'error',
        text: 'Ocorreu um erro ao consultar o proprietário.'
      }).then(() => {
        this.loading = false;
      });
    });
  }

  pesquisarProprietarioBCadastros(): void {
    const cpfCnpj = this.informacoesExploracaoForm.controls.cpfCnpjProprietario.value.replace(/\D/g, '');
    const isCpf = cpfCnpj.length === 11;
    const isCnpj = cpfCnpj.length === 14;

    if (!isCpf && !isCnpj) {
      this.loading = false; 
      return;
    }

    const consulta$ = isCpf
      ? this.contribuinteService.consultarCpfBcadastro(cpfCnpj)
      : this.contribuinteService.consultarCnpjBcadastro(cpfCnpj);

    consulta$.subscribe(
      (res: any) => {
        Swal.fire({
          icon: 'success',
          text: 'Dados do proprietário obtidos do B-Cadastros da Receita Federal.'
        }).then(() => {
          const dados = {
            dscRazaoSocial: isCpf
              ? res.nomeContribuinte
              : (res.nomeEmpresarial || res.nomeFantasia || 'Não informado'),
            email: res.email
          };
          this.preencherCamposProprietario(dados);
          this.loading = false;
        });
      },
      error => {
        this.popupProprietarioNaoEncontrado();
      }
    );
  }

  selecionarProprietario(proprietario): void {
    this.proprietarioSelecionado = proprietario;
  }

  preencherCamposProprietario(dados) {
    const controls = this.informacoesExploracaoForm.controls;
    controls.nomeProprietario.setValue(dados.dscRazaoSocial);
    controls.ieProprietario.setValue(dados.dscIe || '');
    controls.codigoProprietario.setValue(dados.codigo);
    
    if (dados.email) {
      controls.emailProprietario.setValue(dados.email);
    } else if (dados.codigo) {
      this.loading = true;
      this.produtorRuralService.getEmailCadastro(dados.cadastro.codigo).subscribe((emails: Array<any>) => {
        if (emails && emails.length > 0) {
          controls.emailProprietario.setValue(emails[0].descricao);
        }
        this.loading = false;
      }, error => {
        this.loading = false;
      });
    }

    controls.ieProprietario.disable();
    controls.nomeProprietario.disable();
    controls.emailProprietario.disable();

    this.modalProprietario = false;
  }

  limparCamposProprietario(): void {
    const controls = this.informacoesExploracaoForm.controls;
    controls.nomeProprietario.reset();
    controls.ieProprietario.reset();
    controls.emailProprietario.reset();
  }

  limparValidacaoProprietario() {
    this.informacoesExploracaoForm.controls.cpfCnpjProprietario.clearValidators();
    this.informacoesExploracaoForm.controls.cpfCnpjProprietario.updateValueAndValidity();
    this.informacoesExploracaoForm.controls.nomeProprietario.clearValidators();
    this.informacoesExploracaoForm.controls.nomeProprietario.updateValueAndValidity();
  }

  popupProprietarioNaoEncontrado() {
    this.loading = false;
    Swal.fire({
      icon: 'error',
      text: 'CPF/CNPJ não encontrado nas bases Sfera e B-Cadastros. Verifique as informações e tente novamente.'
    }). then(() => {
      this.informacoesExploracaoForm.controls.cpfCnpjProprietario.reset();
      this.limparCamposProprietario();
    });
  }

  onAdesaoCBSChange() {
    const adesaoCBS = this.informacoesEconomicasForm.controls.adesaoCBS.value;
    const cnpjControl = this.informacoesEconomicasForm.controls.cnpj;

    if (adesaoCBS === true) {
      cnpjControl.setValidators([Validators.minLength(14)]);
      cnpjControl.enable();
      cnpjControl.updateValueAndValidity();
    } else {
      cnpjControl.clearValidators();
      cnpjControl.reset();
      cnpjControl.updateValueAndValidity();
      this.cnpjCbsIbsValidado = false;
      this.dadosCnpjCbsIbs = null;
    }
  }

  buscarCnpjBcadastros(cnpjValue: string) {
    if (!cnpjValue || cnpjValue.length === 0) {
      return;
    }
    const cnpjSemMascara = cnpjValue.replace(/\D/g, '');

    if (!cnpj.isValid(cnpjSemMascara)) {
      this.informacoesEconomicasForm.controls.cnpj.setErrors({ invalid: true });
      Swal.fire({
        icon: 'error',
        text: 'CNPJ inválido conforme B-Cadastros da RFB. Verifique os dados.',
        confirmButtonText: 'OK'
      });
      this.cnpjCbsIbsValidado = false;
      return;
    }

    this.consultarCnpjBcadastrosCbsIbs(cnpjSemMascara);
  }

  consultarCnpjBcadastrosCbsIbs(cnpj: string) {
    this.loadingValidacaoCnpjCbsIbs = true;
    this.cnpjCbsIbsValidado = false;

    // Mock para CNPJ específico
    if (cnpj === '12345678000195') {
      this.loadingValidacaoCnpjCbsIbs = false;
      this.cnpjCbsIbsValidado = false;
      this.dadosCnpjCbsIbs = null;
      
      Swal.fire({
        icon: 'warning',
        title: 'Serviço Indisponível',
        text: 'Serviço da Receita Federal indisponível no momento. Conclusão bloqueada até a validação.',
        confirmButtonText: 'OK'
      });

      this.informacoesEconomicasForm.controls.cnpj.reset();
      this.informacoesEconomicasForm.controls.cnpj.enable();
      
      return;
    }

    this.contribuinteService.consultarCnpjBcadastro(cnpj)
      .pipe(
        timeout(15000),
        catchError(err => {
          this.loadingValidacaoCnpjCbsIbs = false;
          this.cnpjCbsIbsValidado = false;
          this.dadosCnpjCbsIbs = null;
          
          Swal.fire({
            icon: 'warning',
            title: 'Serviço Indisponível',
            text: 'Serviço da Receita Federal indisponível no momento. Conclusão bloqueada até a validação.',
            confirmButtonText: 'OK'
          });

          this.informacoesEconomicasForm.controls.cnpj.reset();
          this.informacoesEconomicasForm.controls.cnpj.enable();
          
          return of(null);
        })
      )
      .subscribe(
        (response: any) => {
          this.loadingValidacaoCnpjCbsIbs = false;
          
          if (response && response.cnpj) {
            this.dadosCnpjCbsIbs = response;
            this.cnpjCbsIbsValidado = true;
            
            Swal.fire({
              icon: 'success',
              text: 'CNPJ confirmado pela RFB.',
              confirmButtonText: 'OK'
            });

          } else {
            // Resposta sem dados válidos
            this.cnpjCbsIbsValidado = false;
            this.dadosCnpjCbsIbs = null;
            
            Swal.fire({
              icon: 'error',
              text: 'CNPJ não encontrado no B-Cadastros/RFB. Verifique o número informado.',
              confirmButtonText: 'OK'
            });

            this.informacoesEconomicasForm.controls.cnpj.reset();
            this.informacoesEconomicasForm.controls.cnpj.enable();
          }
        }
      );
  }

  adicionarCnae() {
    const cnaeSelecionadoIndex = this.cnaeForm.controls.cnae.value;
    const cnaeSelecionado = this.listaCnae[cnaeSelecionadoIndex];
    if (this.cnaePrincipal == true && this.cnaeForm.controls.atividadePrincipal.value == 1) {
      Swal.fire({
        icon: 'warning',
        text: `Atenção: Já existe um CNAE marcado como principal. Para prosseguir, altere o anterior para secundário e depois marque este como principal.`
      })
    } else {
      const idCnaeExistente = this.cnae.some(item => item.cnae.id === cnaeSelecionado.id);
      if (idCnaeExistente) {
        Swal.fire({
          icon: 'error',
          text: `Este CNAE já foi adicionado à lista.`
        });
        return;
      }
      this.nomeCnae = '';
      let obj = {
        cnae: {
          id: this.listaCnae[this.cnaeForm.controls.cnae.value].id
        },
        numPrincipal: this.cnaeForm.controls.atividadePrincipal.value,
        numPrimaria: this.cnaeForm.controls.atividadePrimaria.value,
        cnaeTexto: '',
        principalTexto: '',
        exercidoTexto: '',
        id: this.cnaeCounter
      }
      let index = this.listaCnae[this.cnaeForm.controls.cnae.value].id;
      for (let i = 0; i < this.listaCnae.length; i++) {
        if (index == this.listaCnae[i].id) {
          obj.cnaeTexto = this.listaCnae[i].dscCnae;
          break
        }
      }

      if (this.cnaeForm.controls.atividadePrincipal.value == 1) {
        obj.principalTexto = 'Sim'
      } else {
        obj.principalTexto = 'Não'
      }

      if (this.cnaeForm.controls.atividadePrimaria.value == 1) {
        obj.exercidoTexto = 'Sim'
      } else {
        obj.exercidoTexto = 'Não'
      }

      if (this.cnaeForm.controls.atividadePrincipal.value == 1) {
        this.cnaePrincipal = true;
        this.informacoesEconomicasForm.controls.cnaePrincipal.setValue(cnaeSelecionado);
      }

      this.cnae.push(obj);
      this.cnaeCounter++;
      this.cnaeAberto = false;
      this.cnaeForm.reset();
      this.cnaeForm.controls.atividadePrimaria.setValue("1");
    }

  }

  deletarCnae(item) {
    for (let i = 0; i < this.cnae.length; i++) {
      if (this.cnae[i].id == item.id) {
        if (this.cnae[i]['numPrincipal'] == 1) {
          this.cnaePrincipal = false;
          this.informacoesEconomicasForm.controls.cnaePrincipal.reset();
        }
        this.cnae.splice(i, 1);
      }
    }
  }

  preencherDadosSocio() {
    if (this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 1 || this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 9) {
      this.sociosForm.controls.nome.setValue(this.dataCar?.proprietariosPosseirosConcessionarios[0]?.nome);
      this.sociosForm.controls.cpfCnpj.setValue(this.dataCar?.proprietariosPosseirosConcessionarios[0]?.cpfCnpj);
      this.sociosForm.controls.cpfCnpj.disable();
      this.sociosForm.controls.nome.disable();
      const dataInicio = this.dataInicioProdutorRural;
      const formattedDate = dataInicio.format('DD/MM/YYYY');
      this.sociosForm.controls.dataEntrada.setValue(formattedDate);
      this.dataInicioSocio = formattedDate;
      this.sociosForm.controls.tipoPessoa.setValue(1);
      this.sociosForm.controls.funcaoPropriedadeRural.setValue(1);
      this.sociosForm.controls.participacao.setValue(100);
      this.sociosForm.controls.tipoPessoa.disable();
      this.sociosForm.controls.funcaoPropriedadeRural.disable();
      this.sociosForm.controls.participacao.disable();
      this.sociosForm.controls.dataEntrada.disable();
    }

    else if (this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 12) {
      if (!this.dadosPreenchidos) {
        this.sociosForm.controls.nome.setValue(this.dataCar?.proprietariosPosseirosConcessionarios[0]?.nome);
        this.sociosForm.controls.cpfCnpj.setValue(this.dataCar?.proprietariosPosseirosConcessionarios[0]?.cpfCnpj);
        this.sociosForm.controls.cpfCnpj.disable();
        this.sociosForm.controls.nome.disable();
      }
      this.sociosForm.controls.tipoPessoa.setValue(1);
      this.sociosForm.controls.tipoPessoa.disable();
      this.sociosForm.controls.funcaoPropriedadeRural.setValue(1);
      this.sociosForm.controls.funcaoPropriedadeRural.disable();
    }
    else {
      this.sociosForm.controls.tipoPessoa.setValue(1);
      this.sociosForm.controls.participacao.setValue('');
      this.sociosForm.controls.tipoPessoa.disable();
      this.sociosForm.controls.participacao.enable();
    }
  }

  adicionarSocio() {
    const funcoesMap = {
      1: 'Titular',
      2: 'Administrador',
      3: 'Sócio',
    };
    this.dadosPreenchidos = true;

    this.sociosForm.controls.cep.removeValidators(Validators.required);
    this.sociosForm.controls.numero.removeValidators(Validators.required);
    this.sociosForm.controls.enderecoCompleto.removeValidators(Validators.required);
    this.sociosForm.controls.complemento.removeValidators(Validators.required);
    let obj = {
      dscCpfCnpj: this.sociosForm.controls.cpfCnpj.value,
      dscNomeSocio: this.sociosForm.controls.nome.value,
      rg: this.sociosForm.controls.rg.value,
      participacao: `${this.sociosForm.controls.participacao.value}`,
      datInicio: dayjs(this.dataInicioSocio).format('YYYY-MM-DD'),
      datFim: this.dataFimSocio != null ? dayjs(this.dataFimSocio).format('YYYY/MM/DD') : null,
      funcaoPropriedadeRural: funcoesMap[this.sociosForm.controls.funcaoPropriedadeRural.value],
      numTipoPessoa: this.sociosForm.controls.tipoPessoa.value,
      logradouro: this.sociosForm.controls.logradouro.value,
      numero: this.sociosForm.controls.numero.value,
      socioEndereco: {
        endereco: {
          dscNumero: this.sociosForm.controls.numero.value,
          dscComplemento: this.sociosForm.controls.complemento.value,
          dscEnderecoExterior: this.sociosForm.controls.enderecoCompleto.value,
          cep: {
            codCep: this.sociosForm.controls.cep.value
          },
          pais: {
            codigo: this.sociosForm.controls.pais.value
          },
          tipoComplemento: {
            codigo: null
          },
          latitude: this.sociosForm.controls.latitude.value,
          longitute: this.sociosForm.controls.longitude.value,
          naturezaImovel: {
            codigo: 2
          }
        },
        tipoEndereco: {
          codigo: 2
        }
      },
      id: this.sociosCounter,
      valueComplemento: this.sociosForm.controls.tipoComplemento.value
    }
    this.sociosForm.controls.tipoComplemento.value
      ? obj.socioEndereco.endereco.tipoComplemento.codigo = this.listaComplemento[this.sociosForm.controls.tipoComplemento.value].codigo
      : '';

    if (this.dataFimSocio != null) {
      obj.datFim = dayjs(this.dataFimSocio).format('YYYY-MM-DD')
    }

    this.participacaoCounter += this.sociosForm.controls.participacao.value;

    if (this.participacaoCounter > 100) {
      this.participacaoCounter -= this.sociosForm.controls.participacao.value;
      this.sociosForm.controls.participacao.setErrors({ invalid: true });
      return
    }

    this.socios.push(obj);
    this.sociosAberto = false;
    this.sociosForm.reset();
    this.sociosForm.controls.nome.enable();
    this.sociosForm.controls.cpfCnpj.enable();
    this.pais = 30;
    this.verificarPais();

    if (this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 1 && this.socios.length == 1) {
      this.liberarAdicao = false;
    }

    if (this.participacaoCounter == 100) {
      this.liberarAdicao = false;
    }
  }

  deletarSocio(item) {
    for (let i = 0; i < this.socios.length; i++) {
      if (this.socios[i].id == item.id) {
        this.participacaoCounter -= this.socios[i].participacao;
        this.socios.splice(i, 1);
      }
    }

    if (this.participacaoCounter < 100) {
      this.liberarAdicao = true;
    }

    if (this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 1 && this.socios.length == 0) {
      this.liberarAdicao = true;
    }

    if (this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 1) {
      this.sociosForm.controls.tipoPessoa.setValue('1');
      this.sociosForm.controls.participacao.setValue(100);
      this.sociosForm.controls.tipoPessoa.disable();
      this.sociosForm.controls.participacao.disable();
    }
  }

  abrirModal(modal: string) {
    if (modal == 'cnae') {
      this.cnaeAberto = true;
      this.cnaeForm.reset();
      this.cnaeForm.controls.atividadePrimaria.setValue("1");
    } else if (modal == 'socios') {
      this.preencherDadosSocio()
      this.sociosAberto = true;
      this.changeDetector.detectChanges();

      if (this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 1) {
        this.renderer.addClass(this.tipoPessoaSocio.nativeElement, 'radio-disabled');
      } else {
        this.sociosForm.controls.participacao.enable();
      }
    }
  }

  fecharModal(modal: string) {
    if (modal == 'cnae') {
      this.nomeCnae = '';
      this.cnaeAberto = false;
      this.cnaeForm.reset();
    } else if (modal == 'socios') {
      this.sociosAberto = false;
      this.sociosForm.reset();
      this.pais = 30;
      this.verificarPais();
      if (this.informacoesExploracaoForm.controls.categoriaOcupacao.value == 1) {
        this.sociosForm.controls.tipoPessoa.setValue('1');
        this.sociosForm.controls.participacao.setValue(100);
        this.sociosForm.controls.tipoPessoa.disable();
        this.sociosForm.controls.participacao.disable();
      }
    } else if(modal == 'proprietario') {
      this.modalProprietario = false;
      this.proprietarioSelecionado = null;
      this.informacoesExploracaoForm.controls.cpfCnpjProprietario.reset();
      this.limparCamposProprietario();
    }
  }

  getDataInicio(event, form: string) {
    if (form == 'exploracaoAtividade') {
      if (this.dataInicioProdutorRural && this.dataInicioProdutorRural >= this.dataAtual) {
        this.informacoesExploracaoForm.controls.dataInicio.reset();
        this.informacoesExploracaoForm.controls.dataTermino.reset();
        this.informacoesExploracaoForm.controls.dataTermino.disable();
        console.log('this.dataInicioProdutorRural', this.dataInicioProdutorRural)
        Swal.fire({
          icon: 'warning',
          text: 'Data de Início não pode ser maior que a data atual.'
        });
      }
      if (this.dataInicioProdutorRural && this.dataInicioProdutorRural < this.dataAtual) {
        this.informacoesExploracaoForm.controls.dataTermino.enable();
        this.dataInicioProdutorRural = event;
      }
    }

    if (form == 'informacoesEconomicas') {
      this.dataRegistro = event;
    }

    if (form == 'socios') {
      if (this.dataInicioSocio && this.dataInicioSocio >= this.dataAtual) {
        this.sociosForm.controls.dataEntrada.reset();
        Swal.fire({
          icon: 'warning',
          text: 'Data da Entrada não pode ser maior que a data atual.'
        });
      }

      if (this.dataInicioSocio && this.dataInicioSocio < this.dataAtual) {
        this.dataInicioProdutorRural = event;
      }
    }
  }

  getDataFim(event, form: string) {
    if (form === 'exploracaoAtividade') {
      this.dataFimProdutorRural = event;

      if (this.dataFimProdutorRural &&
        (this.dataFimProdutorRural <= this.dataInicioProdutorRural ||
          this.dataFimProdutorRural >= this.dataAtual)) {

        this.informacoesExploracaoForm.controls.dataTermino.reset();
        Swal.fire({
          icon: 'warning',
          text: 'Término da Atividade deve ser maior que a Data de Início e menor que a data atual.'
        });
      }

    }

    if (form == 'socios') {
      if (
        this.dataFimSocio
        && (this.dataFimSocio <= this.dataInicioSocio || this.dataFimSocio >= this.dataAtual)
      ) {
        this.sociosForm.controls.dataSaida.reset();
        Swal.fire({
          icon: 'warning',
          text: 'Data de Saída deve ser maior que a Data da Entrada e menor que a data atual.'
        })
      }

      if (this.dataFimSocio && this.informacoesExploracaoForm.controls.categoriaOcupacao.value != 1) {
        this.sociosForm.controls.participacao.setValue(0);
        this.sociosForm.controls.participacao.disable();
      }
      this.dataFimSocio = event;
    }
  }

  verificarPais() {
    if (this.pais !== 30) {
      this.sociosForm.controls.enderecoCompleto.addValidators(Validators.required);
      this.sociosForm.controls.cep.removeValidators(Validators.required);
      this.sociosForm.controls.numero.removeValidators(Validators.required);
      this.sociosForm.controls.cep.updateValueAndValidity();
      this.sociosForm.controls.numero.updateValueAndValidity();
      this.sociosForm.controls.enderecoCompleto.updateValueAndValidity();
    } else {
      this.sociosForm.controls.cep.addValidators(Validators.required);
      this.sociosForm.controls.numero.addValidators(Validators.required);
      this.sociosForm.controls.enderecoCompleto.removeValidators(Validators.required);
      this.sociosForm.controls.cep.updateValueAndValidity();
      this.sociosForm.controls.numero.updateValueAndValidity();
      this.sociosForm.controls.enderecoCompleto.updateValueAndValidity();
    }
  }

  validarCep(event: Event, form: string): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    if (/^\d{2}[.-]?\d{3}[.-]?\d{3}$/.test(inputValue)) {
      this.verificarCep(inputValue, form);
    } else {
      if (form == 'enderecoPropriedade') {
        this.apagarEndereco('enderecoPropriedade');
      } else if (form == 'enderecoCorrespondencia') {
        this.apagarEndereco('enderecoCorrespondencia');
      } else if (form == 'socios') {
        this.apagarEndereco('socios');
      } else if (form == 'contabilista') {
        this.apagarEndereco('contabilista');
      }
    }
  }

  verificarCep(cep, form: string) {
    this.loading = true;
    const cepLimpo = cep.replace(/\D/g, '');
    this.produtorRuralService.consultarCep(cepLimpo).subscribe(
      res => {
        if (form == 'socios') {
          this.sociosForm.controls.logradouro.setValue(res['dscLogradouro']);
          this.sociosForm.controls.logradouro.disable();
        } else if (form == 'enderecoPropriedade') {
          this.enderecoCorrespondencia = res;
          const camposEndereco = [
            { nome: 'logradouro', valor: res['dscLogradouro'] },
            { nome: 'bairro', valor: res['dscBairro'] },
            { nome: 'municipio', valor: res['cidade']['dscCidade'] },
            { nome: 'estado', valor: res['cidade']['estado']['codigo'] }
          ];
          this.preencherEnderecoForm(this.enderecoPropriedadeForm, camposEndereco);
        } else if (form == 'contabilista') {
          const camposEndereco = [
            { nome: 'logradouro', valor: res['dscLogradouro'] },
            { nome: 'municipio', valor: res['cidade']['dscCidade'] },
            { nome: 'estado', valor: res['cidade']['estado']['codigo'] },
            { nome: 'bairro', valor: res['dscBairro'] }
          ];
          this.preencherEnderecoForm(this.contabilistaForm, camposEndereco);
        }
      },
      err => {
        Swal.fire({
          icon: 'error',
          text: 'Atenção: C.E.P não encontrado/válido. Informar um próximo ou genérico da cidade.'
        }).then(result => {
          if (result.isConfirmed) {
            if (form == 'socios') {
              this.sociosForm.controls.cep.reset();
              this.cepSocios.nativeElement.focus();
              this.apagarEndereco('socios');
            } else if (form == 'enderecoPropriedade') {
              this.enderecoPropriedadeForm.controls.cep.reset();
              this.cepEnderecoPropriedade.nativeElement.focus();
              this.apagarEndereco('enderecoPropriedade');
            } else if (form == 'contabilista') {
              this.contabilistaForm.controls.cep.reset();
              this.apagarEndereco('contabilista');
            }
          }
        });
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    )
  }

  preencherEnderecoForm(formGroup: FormGroup, camposEndereco: { nome: string, valor: any }[]) {
    const camposNaoLocalizados: string[] = [];

    camposEndereco.forEach(campo => {
      formGroup.controls[campo.nome].setValue(campo.valor);
      formGroup.controls[campo.nome].disable();
      if (campo.valor === 'Não Localizados nos Correios' || campo.valor === '') {
        camposNaoLocalizados.push(campo.nome);
      }
    });

    if (camposNaoLocalizados.length > 0) {
      Swal.fire({
        icon: 'warning',
        text: `Endereço não localizado nos Correios. Os dados informados manualmente são de responsabilidade do usuário. Certifique-se de que as informações estão corretas antes de prosseguir. Deseja continuar com o preenchimento manual?`,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true
      }).then(result => {
        if (result.isConfirmed) {
          camposNaoLocalizados.forEach(campo => {
            formGroup.controls[campo].enable();
            formGroup.controls[campo].setValue('');
          });
        }
      });
    }
    this.loading = false;
  }

  apagarEndereco(form) {
    if (form == 'enderecoPropriedade') {
      this.enderecoPropriedadeForm.controls.logradouro.reset();
      this.enderecoPropriedadeForm.controls.bairro.reset();
      this.enderecoPropriedadeForm.controls.municipio.reset();
      this.enderecoPropriedadeForm.controls.estado.reset();
      this.enderecoPropriedadeForm.controls.logradouro.enable();
      this.enderecoPropriedadeForm.controls.bairro.enable();
      this.enderecoPropriedadeForm.controls.municipio.enable();
      this.enderecoPropriedadeForm.controls.estado.enable();
    } else if (form == 'socios') {
      this.sociosForm.controls.logradouro.reset();
      this.sociosForm.controls.logradouro.enable();
    } else if (form == 'contabilista') {
      this.contabilistaForm.controls.logradouro.reset();
      this.contabilistaForm.controls.municipio.reset();
      this.contabilistaForm.controls.estado.reset();
      this.contabilistaForm.controls.bairro.reset();
    }
  }

  validarCategoriaOcupacao() {
    const categoriaOcupacao = this.informacoesExploracaoForm.controls.categoriaOcupacao.value;
    this.exibirDadosProprietario = false;
    this.dadosCedente = false;
    this.toggleCamposProprioObrigatorios(false);

    if(categoriaOcupacao.codigo == 1) {
      this.toggleCamposProprioObrigatorios(true);
    } else if(!categoriaOcupacao.descricao?.toLowerCase().includes('posse')) {
      this.dadosProprietarioObrigatorio();
      this.dadosCedente = true;
    }

    this.digitarCar = true;
  }

  toggleCamposProprioObrigatorios(obrigatorio: boolean) {
    const controlNames = [
      'registroImobiliario',
      'livroProprietario',
      'folhaProprietario',
      'numeroMatricula'
    ];

    for (const name of controlNames) {
      const control = this.informacoesExploracaoForm.get(name);
      if (control) {
        if (obrigatorio) {
          control.setValidators([Validators.required]);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity();
      }
    }
  }

  validarCepCategoriaOcupacao(event): void {
    const cep = event.target.value;
    if(!cep) {
      return
    }
    this.loading = true;
    this.produtorRuralService.validarCepCategoriaOcupacao(cep).subscribe((res) => {
      this.loading = false;
    }, erro => {
      this.loading = false;
      const mensagemCep = erro.error?.mensagemCep;
      Swal.fire({
        icon: 'error',
        text: mensagemCep
      }).then(() => {
        this.formValidacaoEndereco.controls.cep.setValue('');
      })
    });
  }

  consultarCrc(crc) {
    this.loadingCrc = true;
    this.produtorRuralService.consultarCrc(crc)
      .pipe(
        timeout(5000),
        catchError(err => {
          this.loadingCrc = false;
          Swal.fire({
            icon: 'warning',
            text: `Atenção: Não foi possível validar os dados junto ao C.R.C. 
            Será Permitida a digitação dos dados que serão validados posteriormente pela Auditoria Fiscal.`
          })
          return err;
        })
      )
      .subscribe(
        res => {
          this.loadingCrc = false;
          Swal.fire({
            icon: 'warning',
            text: `Atenção: Não foi possível validar os dados junto ao C.R.C. 
              Será Permitida a digitação dos dados que serão validados posteriormente pela Auditoria Fiscal.`
          })
        }
      )
  }

  anexo(event, tipo: string) {
    const files: FileList = event.target.files;
    const validTypes = ['image/jpeg', 'image/jpg', 'image/gif', 'application/pdf'];
    const arquivosValidos: File[] = [];
  
    for (let i = 0; i < files.length; i++) {
      const fileName = files[i].name;
      const fileNameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'));
      
      if (fileNameWithoutExtension.length > 60) {
        Swal.fire({
          text: 'O nome do arquivo excede o limite de 60 caracteres.',
          icon: 'info',
          confirmButtonText: 'OK'
        });
        if (this.fileInput && this.fileInput.nativeElement) {
          this.fileInput.nativeElement.value = '';
        }
        return;
      }
    }
    
    for (let i = 0; i < files.length; i++) {
      if (validTypes.includes(files[i].type)) {
        arquivosValidos.push(files[i]);
      }
    }

    this.arquivoValido = arquivosValidos.length === files.length;

    if (tipo == 'propriedade') {
      this.arquivos = [...this.arquivos, ...arquivosValidos];
      this.informacoesExploracaoForm.controls.documentosComprovacao.setValue(this.arquivos);
    } else if (tipo == 'contabilista') {
      this.arquivosComprovacaoContabilista = [...this.arquivosComprovacaoContabilista, ...arquivosValidos];
      this.contabilistaForm.controls.documentosContabilista.setValue(this.arquivosComprovacaoContabilista);
    }

    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  deletarArquivo(index: number, tipo: string) {
    if (tipo === 'propriedade') {
      if (typeof index === 'number') {
        this.arquivos.splice(index, 1);
      } else {
        this.arquivos = [];
        this.fileInput.nativeElement.value = '';
      }
      this.informacoesExploracaoForm.controls.documentosComprovacao.setValue(this.arquivos);
    } else if (tipo === 'contabilista') {
      if (typeof index === 'number') {
        this.arquivosComprovacaoContabilista.splice(index, 1);
      } else {
        this.arquivosComprovacaoContabilista = [];
        this.fileInput.nativeElement.value = '';
      }
      this.contabilistaForm.controls.documentosContabilista.setValue(this.arquivosComprovacaoContabilista);
    }
  }

  limparArquivosContabilista(): void {
    this.arquivosComprovacaoContabilista = [];
    this.contabilistaForm.controls.documentosContabilista.setValue(null);
    this.contabilistaForm.controls.documentosContabilista.markAsUntouched();
    this.contabilistaForm.controls.crc.reset();
    this.contabilistaForm.controls.crc.markAsUntouched();
  }

  cadastrarProdutorRural() {
    this.loading = true;

    let obj: CadastroProdutorRural = {
      cadastro: {
        cpfCnpj: this.cadastroEmUso.cpfCnpj
      },
      bic: {
        cadastro: {
          codigo: this.cadastroEmUso.codigo
        }
      },
      contribuinte: {
        dscRazaoSocial: this.contribuinteEmUsoFormatado.dscRazaoSocial,
        dscCpfCnpj: this.cpfCnpjSolicitante,
        datInicioAtiv: dayjs(this.informacoesExploracaoForm.controls.dataInicio.value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        datFimAtiv: this.informacoesExploracaoForm.controls.dataFim.value ? dayjs(this.informacoesExploracaoForm.controls.dataFim.value, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        codCategEstabelecimento: 1,
        codClassificacao: this.informacoesEconomicasForm.controls.classificacaoContribuinte.value,
        codPorteEmpresa: 0
      },
      solicitanteCadastro: {
        numProcuracao: this.nProcuracaoResponsavel || null,
        cpfCnpj: this.cpfCnpjResponsavel || this.cpfCnpjSolicitante,
        dscEmail: this.emailSolicitante,
        codTipoProcuracao: this.codTipoProcuracao || null,
        dscNomeSolicitante: this.nomeResponsavel || this.contribuinteEmUsoFormatado.dscRazaoSocial,
        dataInicioVigencia: dayjs(this.dataInicioVigencia, 'DD/MM/YYYY').isValid() ? dayjs(this.dataInicioVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        dataFimVigencia: dayjs(this.dataFinalVigencia, 'DD/MM/YYYY').isValid() ? dayjs(this.dataFinalVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
      },
      informacoesFiscaisContribuinte: {
        contribuinteRegimeRecolhimentoDTO: {
          tipoRegimeRecolhimento: {
            id: this.informacoesEconomicasForm.controls.regimeRecolhimento.value.id,
          },
        },
        naturezaJuridicaContribuinteDTO: {
          naturezaJuridica: {
            id: this.informacoesEconomicasForm.controls.naturezaJuridica.value,
          },
        },
        cnaeContribuinteDTO: []
      },
      numCBSIBS: this.informacoesEconomicasForm.controls.adesaoCBS.value ? 1 : 0,
      dscCNPJCBSIBS: this.informacoesEconomicasForm.controls.cnpj?.value?.replace(/\D/g, ''),
      imovelDTO: {
        observacao: this.informacoesExploracaoForm.controls.observacao.value,
        endereco: {
          dscNumero: this.enderecoPropriedadeForm.controls.numero.value,
          dscComplemento: this.enderecoPropriedadeForm.controls.descricaoAcesso.value,
          dscBairro: this.enderecoPropriedadeForm.controls.bairro.value,
          dscLogradouro: this.enderecoPropriedadeForm.controls.logradouro.value,
          tipoComplemento: {
            codigo: this.enderecoPropriedadeForm.controls.tipoComplemento?.value?.codigo ? this.enderecoPropriedadeForm.controls.tipoComplemento?.value?.codigo : null
          },
          cep: {
            codCep: this.enderecoPropriedadeForm.controls.cep.value,
          },
          latitude: this.enderecoPropriedadeForm.controls.latitude.value,
          longitute: this.enderecoPropriedadeForm.controls.longitude.value,
        },
        vlrImovel: this.informacoesExploracaoForm.controls.valorEstimadoImovel.value,
        codTipoUnidadeImovel: 1,
        numAreaTotal: this.informacoesExploracaoForm.controls.areaImovel.value ? parseFloat(String(this.informacoesExploracaoForm.controls.areaImovel.value).replace(',', '.')) : null,
        numAreaTerreno: this.informacoesExploracaoForm.controls.areaImovel.value ? parseFloat(String(this.informacoesExploracaoForm.controls.areaImovel.value).replace(',', '.')) : null,
        numAreaLiquida: this.informacoesExploracaoForm.controls.areaImovel?.value ? parseFloat(String(this.informacoesExploracaoForm.controls.areaImovel.value).replace(',', '.')) : null,
        dscCartorio: this.informacoesExploracaoForm.controls.numeroMatricula.value,
        dscRegistroCartorio: this.informacoesExploracaoForm.controls.registroImobiliario.value,
        codNaturezaImovel: 2,
        datAquisicao: null,
        codTipoUsoImovel: this.informacoesExploracaoForm.controls.categoriaOcupacao.value.codigo,
        dscCar: this.informacoesExploracaoForm.controls.numeroCar.value,
        dscProtocoloCar: this.informacoesExploracaoForm.controls.protocoloCar.value,
        vlrModuloFiscal: this.informacoesExploracaoForm.controls.modulosFiscais.value ? parseFloat(String(this.informacoesExploracaoForm.controls.modulosFiscais.value).replace(',', '.')) : null,
        codTipoImovelRural: this.informacoesExploracaoForm.controls.tipoImovel.value.codigo,
        dscNomeImovel: this.informacoesExploracaoForm.controls.nomeImovel.value,
        numAreaPastagemNatural: this.informacoesExploracaoForm.controls.areaPastagemNatural.value == "" ? 0 : this.informacoesExploracaoForm.controls.areaPastagemNatural.value,
        numAreaPastagemFormada: this.informacoesExploracaoForm.controls.areaPastagemFormada.value == "" ? 0 : this.informacoesExploracaoForm.controls.areaPastagemFormada.value,
        numAreaInexplorada: this.informacoesExploracaoForm.controls.areaInexplorada.value == "" ? 0 : this.informacoesExploracaoForm.controls.areaInexplorada.value,
        numAreaCultivada: this.informacoesExploracaoForm.controls.areaCultivada.value == "" ? 0 : this.informacoesExploracaoForm.controls.areaCultivada.value,
        vlrPercOcupado: this.informacoesExploracaoForm.controls.ocupacaoSolicitante.value,
        codSituacaoSicar: 1,
        imoveisGed: [],
        dscLivroCartorio: this.informacoesExploracaoForm.controls.livroProprietario.value,
        dscInscricao: this.informacoesExploracaoForm.controls.inscricaoImovel.value,
        dscFolhaCartorio: this.informacoesExploracaoForm.controls.folhaProprietario.value,
        incraList: this.incras.map(numero => ({
          dscIncra: numero,
          codSituacaoIncra: 1,
          datIncra: dayjs().format('YYYY-MM-DD')
        })),
        contribuinte: {
          dscRazaoSocial: this.informacoesExploracaoForm.controls.nomeProprietario.value,
          dscCpfCnpj: this.informacoesExploracaoForm.controls.cpfCnpjProprietario.value,
        }
      },
      proprietarioImovel: this.informacoesExploracaoForm.controls.cpfCnpjProprietario.value ?{
        codigo: this.informacoesExploracaoForm.controls.codigoProprietario.value || null,
        dscIe: this.informacoesExploracaoForm.controls.ieProprietario.value,
        cadastro:{
          cpfCnpj:  this.informacoesExploracaoForm.controls.cpfCnpjProprietario.value,      
          dscNomeCadastro: this.informacoesExploracaoForm.controls.nomeProprietario.value,
          emails: this.informacoesExploracaoForm.controls.emailProprietario.value ? [
            {
              descricao: this.informacoesExploracaoForm.controls.emailProprietario.value
            }
          ] : []
        }
      } : null,
      contabilistaResponsavel: {
        dscDocumento: this.contabilistaForm.controls.crc.value,
        cadastroOutorgado: {
          cpfCnpj: this.contabilistaForm.controls.cpf.value,
          razaoSocial: this.contabilistaForm.controls.nome.value,
          emailUsuario: this.contabilistaForm.controls.email.value
        },
        geds: [],
        contribuinteEndereco: {
          endereco: {
            dscNumero: this.contabilistaForm.controls.numero.value,
            dscComplemento: this.contabilistaForm.controls.complemento.value,
            dscBairro: this.contabilistaForm.controls.bairro.value,
            dscLogradouro: this.contabilistaForm.controls.logradouro.value,
            tipoComplemento: {
              codigo: this.contabilistaForm.controls.tipoComplemento?.value?.codigo
            },
            naturezaImovel: {
              codigo: 1
            },
            cep: {
              codCep: this.contabilistaForm.controls.cep.value,
            },
            pais: {
              codigo: 30
            }
          },
        }
      },
      socioDTO: []
    };

    if (!this.contabilistaForm.controls.cpf.value) {
      obj.contabilistaResponsavel = null;
    }

    obj.informacoesFiscaisContribuinte.cnaeContribuinteDTO = this.cnae.map(cnaeItem => ({
      cnae: cnaeItem.cnae,
      numPrincipal: cnaeItem.numPrincipal,
      numExerceNoEnd: 1
    }));

    for (let i = 0; i < this.socios.length; i++) {
      delete this.socios[i].id;
      delete this.socios[i].paisTexto;
      delete this.socios[i].logradouro;
      delete this.socios[i].numero;
      delete this.socios[i].valueComplemento;
      if (this.socios[i].datFim == null) {
        delete this.socios[i].datFim;
      }
      if (this.socios[i].socioEndereco.endereco.tipoComplemento.codigo == null) {
        delete this.socios[i].socioEndereco.endereco.tipoComplemento;
      }
      obj.socioDTO.push(this.socios[i]);
      if (this.socios[i].socioEndereco.endereco.pais.codigo != 30) {
        delete this.socios[i].socioEndereco.endereco.cep;
      }
    }

    if (this.arquivos.length > 0) {
      let base64 = [];
      for (let i = 0; i < this.arquivos.length; i++) {
        const reader = new FileReader();
        reader.readAsDataURL(this.arquivos[i]);
        reader.onload = () => {
          base64.push(reader.result);
          base64[i] = base64[i].split(',')[1];
          let arquivo = {
            ged: {
              nomeArquivo: this.arquivos[i].name.replace(/\s/g, ''),
              arquivo: base64[i]
            }
          }
          obj.imovelDTO.imoveisGed.push(arquivo);
        }
      }
    }

    if (this.arquivosComprovacaoContabilista.length > 0) {
      let base64 = [];
      for (let i = 0; i < this.arquivosComprovacaoContabilista.length; i++) {
        const reader = new FileReader();
        reader.readAsDataURL(this.arquivosComprovacaoContabilista[i]);
        reader.onload = () => {
          base64.push(reader.result);
          base64[i] = base64[i].split(',')[1];
          let arquivo = {
            idUsuario: this.cadastroEmUso.codigo,
            nomeArquivo: this.arquivosComprovacaoContabilista[i].name.replace(/\s/g, ''),
            arquivo: base64[i],
            numeroDocumento: this.contabilistaForm.controls.crc.value
          }
          obj.contabilistaResponsavel.geds.push(arquivo);
        }
      }
    }

    if(obj.imovelDTO.dscProtocoloCar == "") {
      delete obj.imovelDTO.dscProtocoloCar;
    }
    if (obj.imovelDTO.dscInscricao == "") {
      delete obj.imovelDTO.dscInscricao
    }
    if (!obj.imovelDTO.vlrImovel) {
      delete obj.imovelDTO.vlrImovel;
    }
    if (obj.contribuinte.datFimAtiv == null) {
      delete obj.contribuinte.datFimAtiv;
    }
    if (obj.imovelDTO.endereco.tipoComplemento.codigo == null) {
      delete obj.imovelDTO.endereco.tipoComplemento;
    }
    if (obj.contabilistaResponsavel && !obj.contabilistaResponsavel.contribuinteEndereco.endereco.tipoComplemento.codigo) {
      delete obj.contabilistaResponsavel.contribuinteEndereco.endereco.tipoComplemento;
    }
    if (obj.imovelDTO.numAreaPastagemNatural == null) {
      delete obj.imovelDTO.numAreaPastagemNatural;
    }
    if (obj.imovelDTO.numAreaPastagemFormada == null) {
      delete obj.imovelDTO.numAreaPastagemFormada;
    }
    if (obj.imovelDTO.numAreaCultivada == null) {
      delete obj.imovelDTO.numAreaCultivada;
    }
    if (obj.imovelDTO.numAreaInexplorada == null) {
      delete obj.imovelDTO.numAreaInexplorada;
    }

    if (!obj.imovelDTO.contribuinte.dscCpfCnpj) {
      delete obj.imovelDTO.contribuinte;
    }
    if(!this.informacoesExploracaoForm.controls.cpfCnpjProprietario.value) {
      delete obj.proprietarioImovel;
    }
    if (!obj.dscCNPJCBSIBS) {
      delete obj.dscCNPJCBSIBS;
    }

      setTimeout(() => {
      this.produtorRuralService.cadastrarProdutor(obj).subscribe(
        res => {
          this.loading = false;
          Swal.fire({
            icon: 'success',
            text: 'Dados enviados com sucesso. A homologação poderá ser acompanhada pela Caixa Postal Eletrônica do solicitante. Para acessar o novo perfil, é necessário encerrar a sessão e entrar novamente no sistema. O que deseja fazer?',
            showCancelButton: true,
            confirmButtonText: 'Manter a sessão',
            cancelButtonText: 'Sair',
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
               this.router.navigate(['/inicio']);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
               window.location.href = 'https://sso.acesso.gov.br/logout?post_logout_redirect_uri=https://dec.sefaz.to.gov.br';
            }
          });
        },
        err => {
          Swal.fire({
            icon: 'error',
            text: 'Ops! Ocorreu um erro ao cadastrar o Produtor Rural'
          }).then(() => {
            // this.router.navigate(['cadastro/produtor-rural/inscricao']);
            this.loading = false;
          });
        }
      )
    }, 500);
  }

  onlyNumbers(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onlyNumbersAndSlash(event: KeyboardEvent) {
    const charCode = event.charCode;
   
    if ((charCode < 48 || charCode > 57) && charCode !== 47) {
      event.preventDefault();
    }
  }

  adicionarIncra() {
    const numero = this.informacoesExploracaoForm.controls.numeroIncra.value;
    if (numero && !this.incras.includes(numero)) {
      this.incras.push(numero);
      this.informacoesExploracaoForm.controls.numeroIncra.setValue('');
    }
  }

  removerIncra(index: number) {
    this.incras.splice(index, 1);
  }

  getDataFimFormatada(): string {
    const dataFim = this.informacoesExploracaoForm.controls.dataFim.value;
    if (!dataFim) {
      return 'Não Informado';
    }
    if (typeof dataFim === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dataFim)) {
      return dataFim;
    }
    return dayjs(dataFim).format('DD/MM/YYYY');
  }

  parseAreaImovel(value) {
    if (value == null) {
      return 0;
    }
    if (typeof value === 'number') {
      return value;
    }
    const str = String(value);
    const normalized = str.replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(normalized);
    return isNaN(parsed) ? 0 : parsed;
  }

  formatDecimal(value) {
    const fixed = value.toFixed(1);
    const [int, dec] = fixed.split('.');
    const withThousands = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${withThousands},${dec}`;
  }

  updateAreaOcupacao() {
    const areaStr = this.informacoesExploracaoForm.get('areaImovel')!.value as string;
    const pct = +this.informacoesExploracaoForm.get('ocupacaoSolicitante')!.value || 0;
    const areaNum = this.parseAreaImovel(this.informacoesExploracaoForm.get('areaImovel')!.value);;


    if (areaNum > 0 && pct > 0) {
      const ocupArea = areaNum * (pct / 100);
      const formatted = this.formatDecimal(ocupArea);
      console.log('[updateAreaOcupacao] ocupArea=', ocupArea, 'formatted=', formatted);

      this.informacoesExploracaoForm
        .get('areaOcupacaoSolicitante')!
        .setValue(formatted, { emitEvent: false });
    } else {
      console.log('[updateAreaOcupacao] sem cálculo (areaNum ou pct ≤ 0)');
      this.informacoesExploracaoForm
        .get('areaOcupacaoSolicitante')!
        .setValue(null, { emitEvent: false });
    }
  }

  onAreaFieldFocus(fieldName: string) {
    const control = this.informacoesExploracaoForm.get(fieldName);
    if (control) {
      const value = control.value;
      if (value === '0' || value === 0 || value === '0.0000' || value === '0,0000') {
        control.setValue('', { emitEvent: false });
      }
    }
  }

  onAreaFieldBlur(fieldName: string) {
    const control = this.informacoesExploracaoForm.get(fieldName);
    if (control) {
      const value = control.value;
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '')) {
        control.setValue(0, { emitEvent: false });
      }
    }
  }

  validarSomaAreas() {
    const form = this.informacoesExploracaoForm;
    const areaOcupacaoSolicitante = this.parseAreaImovel(form.get('areaOcupacaoSolicitante')?.value);
    const areaPastagemNatural = this.parseAreaImovel(form.get('areaPastagemNatural')?.value);
    const areaPastagemFormada = this.parseAreaImovel(form.get('areaPastagemFormada')?.value);
    const areaInexplorada = this.parseAreaImovel(form.get('areaInexplorada')?.value);
    const areaCultivada = this.parseAreaImovel(form.get('areaCultivada')?.value);
    const soma = areaPastagemNatural + areaPastagemFormada + areaInexplorada + areaCultivada;
    const isEqual = Math.abs(soma - areaOcupacaoSolicitante) < 0.01;
    
    if (soma == 0) {
      Swal.fire({
        icon: 'warning',
        html: 'É necessário preencher ao menos uma das áreas de ocupação: <b>pastagem natural, pastagem formada, área inexplorada ou área cultivada</b>. O valor informado deve corresponder à área de ocupação total do imóvel.'
      }).then(() => {
        setTimeout(() => {
          this.inputAreaPastagemNatural.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      });
    } else if (areaOcupacaoSolicitante > 0 && !isEqual) {
      Swal.fire({
        icon: 'warning',
        text: 'A soma total das áreas informadas deve ser igual à área de ocupação. Verifique os dados informados.'
      }).then(() => {
        setTimeout(() => {
          this.inputAreaPastagemNatural.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      });
    } else {
      this.verificarCamposInvalidos(form);
    }
  }

  validarPorcentagemOcupacao() {
    if(!this.exibirDadosProprietario) {
      this.informacoesExploracaoForm.controls.cpfCnpjProprietario.reset();
      this.limparCamposProprietario();
      this.limparValidacaoProprietario();
    }

    const camposInvalidos = this.getCamposInvalidos(this.informacoesExploracaoForm);
    if (camposInvalidos.length > 0) {
      this.alertaCampoObrigatorio();
      return;
    }

    if(!this.informacoesExploracaoForm.controls.protocoloCar.value) {
      this.validarSomaAreas();
      return;
    }

    const obj = {
      dscCar: this.informacoesExploracaoForm.controls.protocoloCar.value,
      valorUsoNovoImobiliario: this.informacoesExploracaoForm.controls.ocupacaoSolicitante.value,
    }
    this.produtorRuralService.validarOcupacaoCar(obj).subscribe((res) => {
      this.validarSomaAreas();
    }, error => {
      if(this.dadosCedente) {
        Swal.fire({
          icon: 'question',
          text: 'A porcentagem de ocupação ultrapassa 100%. Deseja prosseguir?',
          showCancelButton: true,
          cancelButtonText: 'Não',
          confirmButtonText: 'Sim'
        }).then(result => {
          if(result.value) {
            this.validarSomaAreas();
          }
        });
      } else {
        const msg = error.error.msg;
        Swal.fire({
          icon: 'warning',
          text: msg
        });
      }
    });
  }

  proximoPasso() {
    if (this.passo == 1) {
      this.active1 = false;
      this.active2 = true;
      this.passo++;
    } else if (this.passo == 2) {
      this.active2 = false;
      this.active3 = true;
      this.passo++;
    } else if (this.passo == 3) {
      this.active3 = false;
      this.active4 = true;
      this.passo++;
    } else if (this.passo == 4) {
      this.active4 = false;
      this.active5 = true;
      this.passo++;
    } else if (this.passo == 5) {
      this.active5 = false;
      this.active6 = true;
      this.passo++;
    } else if (this.passo == 6) {
      this.active6 = false;
      this.active7 = true;
      this.passo++;
    }
  }

  voltarPasso() {
    if (this.passo == 2) {
      this.active2 = false;
      this.active1 = true;
      this.passo--;
    } else if (this.passo == 3) {
      this.active3 = false;
      this.active2 = true;
      this.passo--;
    } else if (this.passo == 4) {
      this.active4 = false;
      this.active3 = true;
      this.passo--;
    } else if (this.passo == 5) {
      this.active5 = false;
      this.active4 = true;
      this.passo--;
    } else if (this.passo == 6) {
      this.active6 = false;
      this.active5 = true;
      this.passo--;
    } else if (this.passo == 7) {
      this.active7 = false;
      this.active6 = true;
      this.passo--;
    } else if (this.passo == 8) {
      this.active8 = false;
      this.active7 = true;
      this.passo--;
    }
  }

  verificarCamposInvalidos(form: FormGroup) {
    const camposInvalidos = this.getCamposInvalidos(form);
    if (camposInvalidos.length > 0) {
      this.alertaCampoObrigatorio();
      return;
    }

    // Validação específica para CBS/IBS
    if (form === this.informacoesEconomicasForm) {
      const adesaoCBS = this.informacoesEconomicasForm.controls.adesaoCBS.value;
      if (adesaoCBS === true && !this.cnpjCbsIbsValidado) {
        Swal.fire({
          icon: 'warning',
          text: 'O CNPJ informado para CBS/IBS não foi validado. Aguarde a validação antes de prosseguir.',
          confirmButtonText: 'OK'
        });
        return;
      }
    }

    this.proximoPasso();
  }

  getCamposInvalidos(form: FormGroup): string[] {
    const camposInvalidos: string[] = [];
    Object.keys(form.controls).forEach(key => {
      form.controls[key].markAsTouched();
      if (form.controls[key].invalid) {
        camposInvalidos.push(key);
      }
    });
    return camposInvalidos;
  }

  alertaCampoObrigatorio() {
    Swal.fire({
      icon: 'warning',
      text: 'Atenção! Preencha os campos obrigatórios'
    });
  }

  desistir() {
    Swal.fire({
      icon: 'question',
      text: 'Atenção! Desistir neste momento implica em descartar todos os dados digitados. Confirma?',
      confirmButtonText: 'Sim',
      showCancelButton: true,
      cancelButtonText: 'Não'
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate(['cadastro/produtor-rural/inscricao']);
      } else if (result.isDenied) {
        Swal.close();
      }
    })
  }

  popupAjudaSolicitante() {
    Swal.fire({
      icon: 'info',
      text: 'As informações do solicitante são obtidas de fontes oficiais: o nome e o CPF/CNPJ são provenientes da conta gov.br, enquanto o e-mail é recuperado do cadastro realizado pelo usuário no Domicílio Eletrônico do Contribuinte da SEFAZ-TO.'
    });
  }

  truncateText(text: string, maxLength: number = 100): string {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '... ';
  }
}